module.exports = __webpack_public_path__ + "img/116012.2225da70.png";